import { Users, Layers, Cpu, LifeBuoy } from "lucide-react";

import TechSectionHeader from "./TechSectionHeader";
import "./tech-why-oglitz.css";

const reasons = [
  {
    title: "Experienced Engineers",
    icon: Users,
    desc: "A senior-led engineering team with deep experience in building scalable, production-ready systems.",
  },
  {
    title: "Clean & Scalable Code",
    icon: Layers,
    desc: "Maintainable codebases designed for long-term growth, easy updates, and team collaboration.",
  },
  {
    title: "Modern Architecture",
    icon: Cpu,
    desc: "Cloud-native, modular architectures optimized for performance, security, and scale.",
  },
  {
    title: "Long-Term Support",
    icon: LifeBuoy,
    desc: "Ongoing support, monitoring, and enhancements to ensure your product evolves with your business.",
  },
];

export default function TechWhyOglitz() {
  return (
    <section className="oglitz-tech-why">
      <div className="oglitz-tech-why__container">
        <TechSectionHeader
          title="Why Choose"
          highlight="Oglitz"
          subtitle="Technology decisions driven by business outcomes, scalability, and long-term value."
        />

        <div className="oglitz-tech-why__grid">
          {reasons.map((item, index) => (
            <div key={index} className="oglitz-tech-why__card">
              <item.icon />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
